import React from 'react';

function Modal({ open, title, onClose, children }) {
  if (!open) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
      <div className="card bg-dark border-secondary shadow crimsonscan-modal" style={{ color: '#fff', width: '95%', maxWidth: 1200, maxHeight: '90vh', overflow: 'hidden' }}>
        <div className="card-header d-flex justify-content-between align-items-center border-secondary">
          <div className="fw-semibold">{title}</div>
          <button className="btn btn-outline-light btn-sm" onClick={onClose}>Close</button>
        </div>
        <div className="card-body overflow-auto text-start">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
